// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"93":"32612411","100":"b05d7a30","186":"8ca1bf37","301":"f999f624","489":"cb7592ab","568":"4fd9d1a0","601":"dbc32178","690":"f341f17d","726":"b60d4938","744":"6e80f60d","816":"36552387"}[chunkId] + ".js";
};